import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { DynamicFlowOption } from '../../model/dynamic-flow.types';

@Component({
  selector: 'c-multi-select',
  imports: [],
  templateUrl: './multi-select.component.html',
  styleUrl: './multi-select.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MultiSelectComponent {
  @Input() label: string;
  @Input() description: string;
  @Input() options: DynamicFlowOption[] = [];
  @Input() selectedOptions: DynamicFlowOption[] = null;
  @Output() select = new EventEmitter<DynamicFlowOption[]>();

  hasSelected(option: DynamicFlowOption): boolean {
    return this.selectedOptions?.some((selected) => selected.id === option.id);
  }

  clickOnOption(option: DynamicFlowOption): void {
    if (this.hasSelected(option)) {
      this.removeOption(option);
    } else {
      this.addOption(option);
    }
  }

  addOption(option: DynamicFlowOption): void {
    this.select.emit([...(this.selectedOptions ?? []), option]);
  }

  removeOption(option: DynamicFlowOption): void {
    this.select.emit(this.selectedOptions?.filter((selected) => selected.value !== option.value));
  }
}
